<template>
  <form @submit.prevent>
    <div>
      <h2>
        <span v-if="isEditMode">"{{ editedEntity.name | translate }}" {{ $t("common.update") }}</span>
        <span v-else>{{ $t("process.new") }}</span>
      </h2>

      <sweet-input
        v-model="form.name"
        :isValid="!$v.form.name.$error"
        @input="$v.form.name.$touch()"
        layout="vertical"
        :placeholder="$t('common.name')"
        :label="$t('process.text')"
      />

      <div class="col-mr-5 mt-3">
        <right-panel class="float-right mt-1 " id="sidebar-new-process-category" width="650px" :icon="'mdi mdi-plus'" :text="$t('process-category.new')" @hidden="rightPanelClosed">
          <div class="pl-5 pr-5">
            <Form :hide-library="true" @onSave="onCategorySelect" />
          </div>
        </right-panel>
      </div>

      <h6 class="mt-4">{{ $t("common.category") }}</h6>
      <filter-select
        :validation="true"
        :isValid="!$v.form.category.$invalid"
        id="categoryFilter"
        ref="categoryFilter"
        :placeholder="$t('common.category')"
        :multiple="false"
        @filter="onCategorySearch"
        :selected="form.category"
        @changed="onCategorySelect"
      />

      <br />
      <sweet-textarea
        v-model="form.description"
        :isValid="!$v.form.description.$error"
        @input="$v.form.description.$touch()"
        type="text"
        layout="vertical"
        :placeholder="$t('common.description')"
        :label="$t('process.description')"
        :rows="3"
      />
      <h6 class="mt-4">{{ $t("sector.name") }}</h6>
      <filter-select
        id="sectorFilter"
        ref="sectorFilter"
        :placeholder="$t('sector.text')"
        :multiple="false"
        @filter="onSectorSearch"
        :selected="form.sector"
        @changed="onSectorSelect"
      />
      <br />
      <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating || $v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
        {{ $t("common.save") }}
      </sweet-button>
    </div>
  </form>
</template>

<script>
import SweetTextarea from "@c/form/sweet-textarea";

import Form from "./management-library-process-category-form";

import { maxLength, minLength, required } from "vuelidate/lib/validators";
const state = "managementProcess";

export default {
  components: {
    Form,

    SweetTextarea,
  },
  data() {
    return {
      form: {
        name: undefined,
        description: undefined,
        category: undefined,
      },
      formError: undefined,
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(350),
      },
      description: {
        required,
        minLength: minLength(1),
      },
      category: {
        required,
      },
    },
  },
  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        this.form = { ...this.prepareFormForEdit(v) };
      },
    },
  },
  computed: {
    isUpdating() {
      return this.$store.getters[`${state}/isUpdating`];
    },
    editedEntity() {
      return this.$store.getters[`${state}/editedEntity`];
    },
    isEditMode() {
      return this.$store.getters[`${state}/isEditMode`];
    },
  },
  mounted() {},
  methods: {
    async save() {
      const ok = await this.confirm(this.$t(`alert.approve`));
      if (!ok) {
        return;
      }

      try {
        await this.$store.dispatch(`${state}/save`, this.form);
        this.form = {};
        this.$toast.success(this.$t("common.success"));
        this.$root.$emit("bv::toggle::collapse", "sidebar-new-process");
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    rightPanelClosed() {
      this.$refs.categoryFilter.reset();
    },

    async onSectorSearch(value, callback) {
      const response = await this.$store.dispatch(`managementSector/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onSectorSelect(item) {
      this.form = { ...this.form, sector: item };
    },
    async onCategorySearch(value, callback) {
      const response = await this.$store.dispatch(`managementProcessCategory/paginate`, {
        options: { limit: 200 },
        query: { name: { value }, "scope.value": { value: "system", isObject: true } },
      });

      callback(response.data?.docs ?? []);
    },
    onCategorySelect(item) {
      this.form = { ...this.form, category: item };
    },
  },
};
</script>
